import { Select } from 'antd';
import { fetchPaymentMethods } from '../apis/paymentsApi';
import { useEffect, useState } from 'react';

const PaymentMethod = ({showBill = false, onChange, value, className = '' }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);

  const loadPaymentMethods = async () => {
    let paymentMethods = await fetchPaymentMethods(false, 1);
    if (!showBill) {
      paymentMethods = paymentMethods.filter(
        method => method.name.toLowerCase() !== 'cuenta por pagar'
      );
    }
    setPaymentMethods(paymentMethods);

    if (value && !paymentMethods.some(method => method.id === value)) {
      onChange(undefined);
    }
  };

  useEffect(() => {
    loadPaymentMethods();
  }, [showBill]);

  return (
    <Select
      showSearch
      onChange={onChange}
      value={value}
      placeholder="Método de pago"
      optionFilterProp="label"
      className={className}
      options={paymentMethods.map((paymentMethod) => ({
        value: paymentMethod.id,
        label: paymentMethod.name,
      }))}
    />
  );
};

export default PaymentMethod;
